import { render, staticRenderFns } from "./CartModal.vue?vue&type=template&id=a87d32d4&scoped=true"
import script from "./CartModal.vue?vue&type=script&lang=ts"
export * from "./CartModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87d32d4",
  null
  
)

export default component.exports